import Controller from 'controllers/controller';
import EventManager from 'tools/event-manager';
import {TweenLite} from 'tools/gsap';
import {Power2} from 'tools/gsap';

class FadingGalleryController extends Controller {
    ready(element, options = { }) {
        this.element = element;
        
        // Store instance as property on element object
        this.element.__fadingGalleryInstance = this;
        
        this.options = {
            interval: 4000,
            duration: 1.5
        };
        
        Object.assign(this.options, options);
        
        this.events = new EventManager();
        
        this.elements = { };
        this.timeout = null;
        this.previous = null;
        this.current = 0;
        this.drawing = false;
        
        this.cacheElements();
        this.attachEvents();

        this.setTimeout();
        this.draw();
    }
    
    cacheElements() {
        this.elements.items = Array.from(this.element.querySelectorAll('.item'));
        this.elements.dots = Array.from(this.element.querySelectorAll('.dot'));
    }

    attachEvents() {
        this.events.on(this.element, 'click', this.onClick);

        this.elements.dots.forEach(dot => {
            this.events.on(dot, 'click', this.onDotClick);
        })
    }
    
    beforeDestroy() {
        this.clearTimeout();
        this.events.destroy();
        
        this.app.fadingGalleriesController.removeInstance(this);
    }

    onDotClick(event) {
        event.stopPropagation();
        
        // If an animation is in progress, ignore clicks to save the apparant glitchiness of progressing the slide 
        // before animation is complete.
        if (this.drawing) {
            return;
        }

        this.setCurrent(this.elements.dots.indexOf(event.currentTarget));
        
        this.resetTimeout();
        this.draw();
    }

    onClick() {
        // If an animation is in progress, ignore clicks to save the apparant glitchiness of progressing the slide 
        // before animation is complete.
        if (this.drawing) {
            return;
        }
        
        this.resetTimeout();
        this.next();
    }
    
    clearTimeout() {
        if (this.timeout) {
            clearTimeout(this.timeout);
            
            this.timeout = null;
        }
    }
    
    setTimeout() {
        this.timeout = setTimeout(() => {
            this.next();
            
            this.setTimeout();
        }, this.options.interval);
    }
    
    resetTimeout() {
        this.clearTimeout();
        this.setTimeout();
    }

    next() {
        this.iterate();
        this.draw();
    }
    
    iterate() {
        let next = this.current + 1;

        if (next > this.elements.items.length - 1) {
            next = 0;
        }
        
        this.setCurrent(next);
    }

    setCurrent(index) {
        this.previous = this.current;
        this.current = index;
    }
    
    draw() {
        // Skip drawing if current item is the same as the previous.
        // This will happen in galleries with a single image.
        if (this.current === this.previous) {
            return;
        }
        
        let duration = this.options.duration;
        
        // if falsy, this is the first item to be shown, so don't animate
        if (this.previous === null) {
            duration = 0;
        }
        
        // Prevent clicks during animation
        this.drawing = true;
        
        this.elements.dots.forEach((dot, index) => {
            if (index === this.current) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
        
        this.elements.items.forEach((item, index) => {
            TweenLite.killTweensOf(item);
            
            if (index === this.current) {
                TweenLite.set(item, {
                    opacity: 0,
                    scale: 1.05
                });
            } else if (index === this.previous) {
                TweenLite.set(item, {
                    opacity: 1,
                    scale: 1.025
                });
            } else {
                TweenLite.set(item, {
                    opacity: 0,
                    scale: 1.0,
                    ease: Power2.easeInOut
                });
            }
        });
        
        this.elements.items.forEach((item, index) => {
            if (index === this.current) {
                TweenLite.to(item, duration, {
                    opacity: 1,
                    scale: 1.025,
                    ease: Power2.easeInOut,
                    onComplete: () => {
                        this.drawing = false;
                    }
                });
            } else if (index === this.previous) {
                TweenLite.to(item, duration, {
                    opacity: 0,
                    scale: 1.0,
                    ease: Power2.easeInOut
                });
            }
        });
    }
}

export default FadingGalleryController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/components/fading-gallery.js